import { keepPreviousData } from '@tanstack/react-query';

import { CreativeAssetsPolicy } from '@playq/octopus2-files';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

const policyAssetsQueryKeys: unknown[] = ['corp', 'policies', 'assets', 'query'];

export const usePolicyAssetsQuery = (
  options?: IUseQueryOptionsExtended<CreativeAssetsPolicy | undefined, GenericFailure | Error>
) => {
  return useEitherQuery(policyAssetsQueryKeys, () => services2.creativeAssetsAdminService.retrievePolicy(), {
    placeholderData: keepPreviousData,
    ...options,
  });
};
